export default {
  SUPPORTS_SET_STATE: '@supports/SUPPORTS_SET_STATE',
  SUPPORTS_DATA_REQUEST: '@supports/SUPPORTS_DATA_REQUEST',
  SUPPORTS_GET_REQUEST: '@supports/SUPPORTS_GET_REQUEST',
};
